// import { useGa } from '@/composables/useGa'
import { useOrderHttp } from '@/http/orderHttp'
import { useEstablishmentHttp } from '@/http/establishmentHttp'
import { type Location } from '@/types/Location'
import { getCountry } from "@/router/utils/getCountry"
import { useSessionStore } from "@/stores/useSessionStore"
import { useCartStore } from "@/stores/useCartStore"
import { useCheckoutStore } from "@/stores/useCheckoutStore"

/**
 * @todo: either we use this fully, or we remove this (currently only does method > storeMethod)
 */
export function useBasket() {
  // const { productAttributes } = useProductHttp()
  const { restore } = useOrderHttp()
  const establishmentHttp = useEstablishmentHttp()
  const sessionStore = useSessionStore()
  const cartStore = useCartStore()
  const checkoutStore = useCheckoutStore()

  // const ga = useGa()

  async function changeProductAmountInBasket(hash: string, amount: number) {
    // const basketItems = cartStore.basketItems
    // const item = basketItems.find(item => item.product.hash === hash)
    // const establishment = cartStore.establishment
    if (cartStore.isSyncing) {
      return
    }

    // try {
    //   const product = establishment.productSets
    //     .reduce((prev, { products }) => [ ...prev, ...products ], [])
    //     .find(({ id }) => id === item.product.id)
    //   product.attributes = await productAttributes(item.product.id, establishment.id)
    //
    //   if (amount < item.amount) {
    //     // ga.trackRemoveProduct({
    //     //   product,
    //     //   amount,
    //     //   establishment: establishment,
    //     //   selectedAttributes: item.selectedAttributes,
    //     // })
    //   }
    //
    //   if (amount > item.amount) {
    //     // ga.trackAddProduct({
    //     //   product,
    //     //   amount,
    //     //   establishment: establishment,
    //     //   selectedAttributes: item.selectedAttributes,
    //     // })
    //   }
    // } catch (e) {
    //   // retard
    // }

    await cartStore.changeAmount(hash, amount)
  }

  async function restoreBasketInfo(order: string) {
    const {
      date,
      time,
      instructions,
      address,
      basket,
      stand_id,
      basket: {
        costs,
        distribution,
        establishment: {
          city,
          slug,
        },
        coupon,
        giftcard,
        modal,
      },
    } = await restore(order)

    let location: Location | null = null

    if (address !== null) {
      location = {
        id: address.id ?? null,
        street: address.street,
        houseNumber: address.housenumber,
        zipcode: address.zipcode,
        country: getCountry().value,
        city: address.city,
        coordinates: address.coordinate,
        title: address.title ?? null,
      }
    }

    const [ establishment, distributionInfo ] = await Promise.all([
      establishmentHttp.establishment(
        slug,
        city.country.code,
        city.slug,
      ),
      establishmentHttp.establishmentByDistributionType(
        slug,
        city.country.code,
        city.slug,
        distribution,
        location,
      ),
    ])

    if (location !== null) {
      sessionStore.setLocation(location)
    }

    await Promise.all([
      cartStore.setEstablishment(establishment),
      cartStore.setEstablishmentDistribution(distributionInfo),
      cartStore.setCouponCode(coupon?.code),
      cartStore.setGiftcardCode(giftcard?.code),
      cartStore.setTip(costs.restaurant_tip),
      cartStore.setDistributionDate(date),
      cartStore.setDistributionTime(time),
      cartStore.setDistribution(distribution),
      sessionStore.setDistribution(distribution),
      sessionStore.setOnLocationIdentifier(stand_id !== '' ? stand_id : null),
      checkoutStore.setInstructions(instructions),
    ])

    await Promise.all([
      cartStore.updateCartByServer(basket),
      cartStore.showModalByServer(modal),
    ])
  }

  async function emptyBasket(trackEvent = true) {
    cartStore.clearBasketItems()
    cartStore.setTip(0)
    cartStore.setDistributionDate(null)
    cartStore.setDistributionTime(null)

    if (trackEvent) {
      // ga.trackEmptyCart()
    }
  }

  return {
    changeProductAmountInBasket,
    restoreBasketInfo,
    emptyBasket,
  }
}
